import { useState, useEffect } from 'react';
import { YOUTUBE_CHANNELS } from '../config/youtubeChannels';

const useMultipleLiveStreams = () => {
  const [liveStreams, setLiveStreams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllLiveStreams = async () => {
      try {
        setLoading(true);
        setError(null);

        const apiKey = process.env.REACT_APP_YOUTUBE_API_KEY;
        const channelIdArray = YOUTUBE_CHANNELS;

        if (!apiKey || apiKey === 'YOUR_YOUTUBE_API_KEY_HERE') {
          console.warn('YouTube API key not configured. Using mock data.');
          // Return mock data when API key is not configured
          setLiveStreams([
            {
              channelId: 'mock',
              videoId: 'dQw4w9WgXcQ',
              title: 'Morning Aarti - Live from Temple',
              description: 'Join us for the beautiful morning aarti ceremony. Experience the divine energy and spiritual vibrations as we offer prayers to the deities.',
              thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
              channelTitle: 'Spiritual Temple',
              publishedAt: new Date().toISOString(),
              isLive: true
            }
          ]);
          setLoading(false);
          return;
        }

        if (!channelIdArray || channelIdArray.length === 0) {
          console.warn('No YouTube channel IDs configured. Using mock data.');
          // Return mock data when no channel IDs are configured
          setLiveStreams([
            {
              channelId: 'mock',
              videoId: 'dQw4w9WgXcQ',
              title: 'Morning Aarti - Live from Temple',
              description: 'Join us for the beautiful morning aarti ceremony. Experience the divine energy and spiritual vibrations as we offer prayers to the deities.',
              thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
              channelTitle: 'Spiritual Temple',
              publishedAt: new Date().toISOString(),
              isLive: true
            }
          ]);
          setLoading(false);
          return;
        }

        // Fetch live videos for all channels in parallel
        const promises = channelIdArray.map(async (channelId) => {
          try {
            const url = `https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=${channelId}&eventType=live&type=video&key=${apiKey}`;
            
            const response = await fetch(url);
            
            if (!response.ok) {
              console.error(`Error fetching live video for channel ${channelId}:`, response.status);
              return null;
            }

            const data = await response.json();
            
            if (data.items && data.items.length > 0) {
              const video = data.items[0];
              return {
                channelId,
                videoId: video.id.videoId,
                title: video.snippet.title,
                description: video.snippet.description,
                thumbnail: video.snippet.thumbnails.high?.url || video.snippet.thumbnails.medium?.url,
                channelTitle: video.snippet.channelTitle,
                publishedAt: video.snippet.publishedAt,
                isLive: true
              };
            }
            return null;
          } catch (err) {
            console.error(`Error fetching live video for channel ${channelId}:`, err);
            return null;
          }
        });

        const results = await Promise.all(promises);
        
        // Filter out null results (channels with no live videos)
        const liveVideos = results.filter(result => result !== null);
        
        setLiveStreams(liveVideos);
      } catch (err) {
        console.error('Error fetching live streams:', err);
        setError(err.message);
        setLiveStreams([]);
      } finally {
        setLoading(false);
      }
    };

    fetchAllLiveStreams();
  }, []);

  return { liveStreams, loading, error };
};

export default useMultipleLiveStreams;

